import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaRocket, FaCloud, FaCogs, FaChartLine, FaUsers, FaMobileAlt, FaDatabase, FaLightbulb } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
  {
    icon: <FaLightbulb size={80} color="var(--brand-primary)" />,
    title: "Digital Strategy & Assessment",
    description: "Evaluate your current digital maturity and identify transformation opportunities. We create comprehensive roadmaps that align technology initiatives with business objectives.",
  },
  {
    icon: <FaCloud size={80} color="var(--brand-primary)" />,
    title: "Cloud Migration & Modernization",
    description: "Migrate legacy systems to modern cloud platforms with minimal disruption. We ensure smooth transitions while optimizing for cost, performance, and scalability.",
  },
  {
    icon: <FaCogs size={80} color="var(--brand-primary)" />,
    title: "Process Automation",
    description: "Automate manual workflows and business processes to increase efficiency and reduce errors. We identify automation opportunities and implement solutions that deliver measurable ROI.",
  },
  {
    icon: <FaDatabase size={80} color="var(--brand-primary)" />,
    title: "Data & Analytics Transformation",
    description: "Build data-driven cultures with modern analytics platforms and business intelligence tools. We help you unlock insights from your data to make better decisions.",
  },
  {
    icon: <FaMobileAlt size={80} color="var(--brand-primary)" />,
    title: "Digital Customer Experience",
    description: "Transform customer interactions with modern digital channels and personalized experiences. We design omnichannel strategies that improve engagement and satisfaction.",
  },
  {
    icon: <FaUsers size={80} color="var(--brand-primary)" />,
    title: "Change Management & Training",
    description: "Ensure successful adoption through comprehensive change management and training programs. We help your team embrace new technologies and ways of working.",
  },
  {
    icon: <FaChartLine size={80} color="var(--brand-primary)" />,
    title: "Performance & Scalability",
    description: "Optimize systems for performance and scale to support business growth. We identify bottlenecks and implement solutions that ensure reliability under increasing load.",
  },
  {
    icon: <FaRocket size={80} color="var(--brand-primary)" />,
    title: "Innovation & Emerging Tech",
    description: "Explore and adopt emerging technologies like AI, IoT, and blockchain. We help you stay competitive by identifying and implementing innovations that create business value.",
  },
];

const DigitalTransformation = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Digital Transformation - Syrol Tech</title>
        <meta name="description" content="We help organizations modernize processes, systems, and technology to operate more efficiently and competitively. We enable businesses to become digital-first with scalable, secure, and future-ready solutions." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Digital Transformation"
        pageName="Digital Transformation"
        breadcrumbsImg={bannerbg}
      />
      <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
        <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
        <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
          <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Modernize your business for the digital age</h1>
          <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>We help organizations modernize processes, systems, and technology to operate more efficiently and competitively. We enable businesses to become digital-first with scalable, secure, and future-ready solutions.</p>
          <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Digital Transformation Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default DigitalTransformation;